module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("ui " + _vm.type + " modal"),
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._t("header", [_vm._v("\n            Modal Title\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("content", [_vm._v("\n            Default Body\n        ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._t("footer", [_vm._v("\n            Default Footer\n        ")])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77e17237"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/semvue/components/Modal.vue
// module id = 153
// module chunks = 1